import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import { SearchMenuStates } from 'components/Search/type'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { rem } from 'polished'
import React, { useCallback, useContext, useMemo, useRef } from 'react'
import styled from 'styled-components'
import CruiseLinesSearchList from './CruiseLinesSearchList'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useCruiseSearchFacets from 'hooks/Cruise/useCruiseSearchFacets'
import cx from 'clsx'
import Pane from 'components/Common/Pane/Pane'

const CruiseLineInputFilterWrapper = styled.div`
  &.active {
    position: relative;

    ${mediaQueryUp.md} {
      position: static;
    }
  }
`

const VendorsDropdown = styled(Dropdown)`
  left: ${rem(0)} !important;
`

function CruiseLineInputFilter({ onChange }: { onChange: (values: App.CruiseGlobalFilters) => void}) {
  const dropdownTriggerRef = useRef<HTMLButtonElement>(null)

  const { activeMenu, cruiseLines: searchCruiseLines } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)
  const [cruiseLines] = useCruiseSearchFacets({ facetTypes: ['cruise_lines'] })
  const showDropdown = activeMenu === SearchMenuStates.CruiseLines

  const toggleDropdown = useCallback(() => {
    const nextMenu = showDropdown ? SearchMenuStates.Closed : SearchMenuStates.CruiseLines
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [searchDispatch, showDropdown])

  const onSelect = useCallback((cruiseLines:string[]) => {
    toggleDropdown()
    onChange({ cruiseLines })
  }, [toggleDropdown, onChange])

  const cruiseLineNames = useMemo(() => {
    return cruiseLines
      .filter(({ value }) => searchCruiseLines?.includes(value as string))
      .map(({ name }) => name)
  }, [searchCruiseLines, cruiseLines])

  const vendorName = useMemo(() => {
    const [firstName] = cruiseLineNames
    const more = cruiseLineNames.length > 1 ? `+${cruiseLineNames.length - 1}` : ''
    return firstName && `${firstName} ${more}`
  }, [cruiseLineNames])

  return (
    <CruiseLineInputFilterWrapper className={cx({ active: showDropdown })}>
      <SearchFormField
        onClick={toggleDropdown}
        ref={dropdownTriggerRef}
        label="Cruise lines"
        placeholder="All cruise lines"
        value={vendorName}
      />
      <VendorsDropdown
        triggerRef={dropdownTriggerRef}
        open={showDropdown}
        onClose={toggleDropdown}
        floatingStrategy="absolute"
        width="100%"
        position="bottom-start"
      >
        <Pane shadow>
          <CruiseLinesSearchList onSelect={onSelect} />
        </Pane>
      </VendorsDropdown>
    </CruiseLineInputFilterWrapper>
  )
}

export default CruiseLineInputFilter
